import axios from 'axios'

// Cấu hình axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api'

// Interceptor để log request
axios.interceptors.request.use(
  config => {
    console.log('Request:', config.method.toUpperCase(), config.url)
    return config
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// Interceptor để log response
axios.interceptors.response.use(
  response => {
    console.log('Response:', response.config.url, response.status)
    return response
  }, 
  error => {
    console.error('Response Error:', error.config?.url, error.response?.status, error.message)
    return Promise.reject(error)
  }
)

const state = {
  shifts: [],
  currentShift: null,
  shiftTemplates: [],
  shiftSchedule: [], // Lịch phân ca theo ngày/tuần
  pagination: {
    total: 0,
    page: 1,
    per_page: 10,
    pages: 1
  }
}

const getters = {
  allShifts: state => state.shifts,
  currentShift: state => state.currentShift,
  shiftTemplates: state => state.shiftTemplates,
  shiftSchedule: state => state.shiftSchedule,
  
  // Lấy ca làm việc theo ID
  getShiftById: state => id => {
    return state.shifts.find(shift => shift.id === id)
  },

  // Lọc ca làm việc theo ngày
  getShiftsByDate: state => date => {
    return state.shiftSchedule.filter(schedule => schedule.date === date)
  }
}

const actions = {
  // Lấy danh sách ca làm việc
  async fetchShifts({ commit }) {
    try {
      const response = await axios.get('/shifts')
      console.log('Dữ liệu API trả về:', response.data)
      const { items, total, page, per_page, pages } = response.data
      console.log('Items được trích xuất:', items)
      commit('setShifts', items)
      commit('setPagination', { total, page, per_page, pages })
    } catch (error) {
      console.error('Lỗi khi lấy danh sách ca:', error)
      throw error
    }
  },

  // Lấy thông tin một ca làm việc
  async fetchShift({ commit }, shiftId) {
    try {
      const response = await axios.get(`/shifts/${shiftId}`)
      commit('setCurrentShift', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy thông tin ca:', error)
      throw error
    }
  },

  // Tạo ca làm việc mới
  async createShift({ commit, dispatch }, shiftData) {
    try {
      const response = await axios.post('/shifts', shiftData)
      if (response.status === 201) {
        commit('addShift', response.data)
        // Fetch lại danh sách sau khi tạo thành công
        await dispatch('fetchShifts')
      }
      return response.data
    } catch (error) {
      console.error('Lỗi khi tạo ca mới:', error)
      throw error
    }
  },

  // Cập nhật ca làm việc
  async updateShift({ commit }, { id, data }) {
    try {
      const response = await axios.put(`/shifts/${id}`, data)
      commit('updateShift', response.data)
      return response.data
    } catch (error) {
      console.error('Lỗi khi cập nhật ca:', error)
      throw error
    }
  },

  // Xóa ca làm việc
  async deleteShift({ commit }, shiftId) {
    try {
      await axios.delete(`/shifts/${shiftId}`)
      commit('removeShift', shiftId)
    } catch (error) {
      console.error('Lỗi khi xóa ca:', error)
      throw error
    }
  },

  // Lấy danh sách mẫu ca làm việc
  async fetchShiftTemplates({ commit }) {
    try {
      const response = await axios.get('/shifts/templates')
      commit('setShiftTemplates', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy mẫu ca:', error)
      throw error
    }
  },

  // Lấy lịch phân ca
  async fetchShiftSchedule({ commit }, { startDate, endDate }) {
    try {
      const response = await axios.get('/shifts/schedule', {
        params: { startDate, endDate }
      })
      commit('setShiftSchedule', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy lịch phân ca:', error)
      throw error
    }
  },

  // Phân ca tự động dựa vào thời gian check-in/check-out
  async autoAssignShift({ commit }, attendanceData) {
    try {
      const response = await axios.post('/shifts/auto-assign', attendanceData)
      commit('updateShiftSchedule', response.data)
      return response.data
    } catch (error) {
      console.error('Lỗi khi tự động phân ca:', error)
      throw error
    }
  }
}

const mutations = {
  setShifts(state, shifts) {
    console.log('Mutation setShifts được gọi với:', shifts)
    state.shifts = shifts || []
    console.log('State sau khi cập nhật:', state.shifts)
  },
  setPagination(state, { total, page, per_page, pages }) {
    state.pagination = {
      total: total || 0,
      page: page || 1,
      per_page: per_page || 10,
      pages: pages || 1
    }
  },
  setCurrentShift(state, shift) {
    state.currentShift = shift
  },
  addShift(state, shift) {
    state.shifts.push(shift)
  },
  updateShift(state, updatedShift) {
    const index = state.shifts.findIndex(s => s.id === updatedShift.id)
    if (index !== -1) {
      state.shifts.splice(index, 1, updatedShift)
    }
  },
  removeShift(state, shiftId) {
    state.shifts = state.shifts.filter(s => s.id !== shiftId)
  },
  setShiftTemplates(state, templates) {
    state.shiftTemplates = templates
  },
  setShiftSchedule(state, schedule) {
    state.shiftSchedule = schedule
  },
  updateShiftSchedule(state, updatedSchedule) {
    // Cập nhật từng bản ghi trong lịch phân ca
    updatedSchedule.forEach(update => {
      const index = state.shiftSchedule.findIndex(
        s => s.date === update.date && s.employeeId === update.employeeId
      )
      if (index !== -1) {
        state.shiftSchedule.splice(index, 1, update)
      } else {
        state.shiftSchedule.push(update)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}